/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { RxCross2 } from "react-icons/rx";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { showTost } from "../showTost";
import LodingLottie from "../Lodinglottie";
import PageHeader from "./PageHeader";
import { FiHeart } from "react-icons/fi";
import { emitProfileAction } from "../socket";

const Favorites = () => {
  const { t } = useTranslation();
  const { basUrl, imageBaseURL } = useContext(MyContext);
  const naviget = useNavigate();
  const location = useLocation();

  const [showPage, setShowPage] = useState();
  const [favourite, setFavourite] = useState([]);
  const [newMatch, setNewMatch] = useState([]);
  const [likeMe, setLikeMe] = useState([]);
  const [passed, setPassed] = useState([]);
  const [likesFilter, setLikesFilter] = useState("All");
  const [likesAccess, setLikesAccess] = useState({
    isLocked: false,
    reason: "",
    previews: [],
    count: 0,
  });
  const [userCoords, setUserCoords] = useState({ lat: null, long: null });
  const [isShow, setIsShow] = useState(true);
  const [loading, setLoading] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndex2, setCurrentIndex2] = useState(0);
  const [currentIndex3, setCurrentIndex3] = useState(0);
  const [currentIndex4, setCurrentIndex4] = useState(0);

  const [totalCards, setTotalCards] = useState(0);
  const [totalCards2, setTotalCards2] = useState(0);
  const [totalCards3, setTotalCards3] = useState(0);
  const [totalCards4, setTotalCards4] = useState(0);

  const fetchedRef = useRef(false);
  const loadedTabsRef = useRef({});
  const dirtyTabsRef = useRef({});

  const getUserId = useCallback(() => {
    try {
      return JSON.parse(localStorage.getItem("Register_User") || "{}").id;
    } catch {
      return null;
    }
  }, []);

  const ShowPageHandler = (el) => {
    sessionStorage.setItem("Explore", el);
    setShowPage(el);
    if (dirtyTabsRef.current[el]) {
      loadedTabsRef.current[el] = false;
    }
  };

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    setShowPage(sessionStorage.getItem("Explore") || "Match");

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setUserCoords({ lat: String(pos.coords.latitude), long: String(pos.coords.longitude) });
      },
      (err) => {
        console.warn("Location error:", err);
        setUserCoords({ lat: "0", long: "0" });
      },
      { enableHighAccuracy: true }
    );
  }, []);

  useEffect(() => {
    setShowPage(sessionStorage.getItem("Explore") || "Match");
  }, [location]);

  const fetchData = useCallback(async (url, params, setCards, setTotalCards, pageIndex) => {
    if (params.lat === null || params.long === null) return;
    try {
      setLoading(true);
      const uid = getUserId();
      const response = await axios.post(url, {
        uid,
        lats: params.lat,
        longs: params.long
      });

      if (response.data.Result === "true") {
        const dataList = response.data[params.listName];
        if (params.tabKey === "Like") {
          const isLocked = response.data.is_locked === true ||
            String(response.data.is_locked).toLowerCase() === "true" ||
            String(response.data.is_locked) === "1";
          setLikesAccess({
            isLocked,
            reason: response.data.lock_reason || response.data.ResponseMsg || "",
            previews: response.data.locked_previewlist || [],
            count: Number(response.data.locked_count || 0),
          });
          if (isLocked) {
            setCards([]);
            setTotalCards(0);
            loadedTabsRef.current[params.tabKey] = true;
            setIsShow(false);
            return;
          }
        }
        if (pageIndex === 0) {
          setCards(dataList.slice(0, 12));
        } else {
          setCards(prevCards => [
            ...prevCards,
            ...dataList.slice(pageIndex, pageIndex + 12)
          ]);
        }
        setTotalCards(dataList.length);
        loadedTabsRef.current[params.tabKey] = true;
        setIsShow(false);
      }
    } catch (error) {
      console.error(`Error fetching ${params.listName}:`, error);
    } finally {
      setLoading(false);
    }
  }, [getUserId]);

  const NewMatchHandler = useCallback((lat, long, pageIndex = 0) => {
    fetchData(`${basUrl}new_match`, { lat, long, listName: "profilelist", tabKey: "Match" }, setNewMatch, setTotalCards, pageIndex);
  }, [basUrl, fetchData]);

  const FavouritrHandler = useCallback((lat, long, pageIndex = 0) => {
    fetchData(`${basUrl}favourite`, { lat, long, listName: "favlist", tabKey: "Favorite" }, setFavourite, setTotalCards2, pageIndex);
  }, [basUrl, fetchData]);

  const LikeMeHandler = useCallback((lat, long, pageIndex = 0) => {
    fetchData(`${basUrl}like_me`, { lat, long, listName: "likemelist", tabKey: "Like" }, setLikeMe, setTotalCards3, pageIndex);
  }, [basUrl, fetchData]);

  const PassedHandler = useCallback((lat, long, pageIndex = 0) => {
    fetchData(`${basUrl}passed`, { lat, long, listName: "passedlist", tabKey: "Passed" }, setPassed, setTotalCards4, pageIndex);
  }, [basUrl, fetchData]);

  const loadVisibleList = useCallback((force = false, pageIndex = 0) => {
    if (!showPage || userCoords.lat === null || userCoords.long === null) return;
    if (!force && pageIndex === 0 && loadedTabsRef.current[showPage]) return;

    if (showPage === "Match") {
      NewMatchHandler(userCoords.lat, userCoords.long, pageIndex);
    } else if (showPage === "Like") {
      LikeMeHandler(userCoords.lat, userCoords.long, pageIndex);
    } else if (showPage === "Favorite") {
      FavouritrHandler(userCoords.lat, userCoords.long, pageIndex);
    } else if (showPage === "Passed") {
      PassedHandler(userCoords.lat, userCoords.long, pageIndex);
    }
  }, [FavouritrHandler, LikeMeHandler, NewMatchHandler, PassedHandler, showPage, userCoords.lat, userCoords.long]);

  const refreshVisibleLists = useCallback(() => {
    loadedTabsRef.current[showPage] = false;
    dirtyTabsRef.current[showPage] = false;
    loadVisibleList(true, 0);
  }, [loadVisibleList, showPage]);

  const removeProfileFromLists = useCallback((profileId) => {
    if (!profileId) return;
    const id = String(profileId);
    const removeFrom = (setItems, setCount) => {
      setItems((items) => {
        const next = items.filter((profile) => String(profile?.profile_id) !== id);
        if (next.length !== items.length) {
          setCount((count) => Math.max(0, count - (items.length - next.length)));
        }
        return next;
      });
    };

    removeFrom(setNewMatch, setTotalCards);
    removeFrom(setLikeMe, setTotalCards3);
    removeFrom(setFavourite, setTotalCards2);
    removeFrom(setPassed, setTotalCards4);
  }, []);

  const markTabsDirty = useCallback((tabs) => {
    tabs.forEach((tab) => {
      dirtyTabsRef.current[tab] = true;
      if (tab !== showPage) {
        loadedTabsRef.current[tab] = false;
      }
    });

    if (tabs.includes(showPage)) {
      refreshVisibleLists();
    }
  }, [refreshVisibleLists, showPage]);

  useEffect(() => {
    const handleProfileLiked = () => markTabsDirty(["Like"]);
    const handleMatchCreated = () => markTabsDirty(["Match", "Like"]);
    const handleFavouriteToggled = () => markTabsDirty(["Favorite"]);
    const handleProfileActionRecorded = (event) => {
      const profileId = event?.detail?.profileId || event?.detail?.profile_id;
      removeProfileFromLists(profileId);
      markTabsDirty(["Match", "Like", "Favorite", "Passed"]);
    };

    window.addEventListener("gomeet:profile-liked", handleProfileLiked);
    window.addEventListener("gomeet:match-created", handleMatchCreated);
    window.addEventListener("gomeet:favourite-toggled", handleFavouriteToggled);
    window.addEventListener("gomeet:profile-action-recorded", handleProfileActionRecorded);

    return () => {
      window.removeEventListener("gomeet:profile-liked", handleProfileLiked);
      window.removeEventListener("gomeet:match-created", handleMatchCreated);
      window.removeEventListener("gomeet:favourite-toggled", handleFavouriteToggled);
      window.removeEventListener("gomeet:profile-action-recorded", handleProfileActionRecorded);
    };
  }, [markTabsDirty, removeProfileFromLists]);

  useEffect(() => {
    loadVisibleList(false, 0);
  }, [loadVisibleList]);

  useEffect(() => {
    if (showPage === "Match" && currentIndex > 0) loadVisibleList(true, currentIndex);
  }, [currentIndex, loadVisibleList, showPage]);

  useEffect(() => {
    if (showPage === "Favorite" && currentIndex2 > 0) loadVisibleList(true, currentIndex2);
  }, [currentIndex2, loadVisibleList, showPage]);

  useEffect(() => {
    if (showPage === "Like" && currentIndex3 > 0) loadVisibleList(true, currentIndex3);
  }, [currentIndex3, loadVisibleList, showPage]);

  useEffect(() => {
    if (showPage === "Passed" && currentIndex4 > 0) loadVisibleList(true, currentIndex4);
  }, [currentIndex4, loadVisibleList, showPage]);

  const handleScroll = useCallback(() => {
    if (loading) return;
    const ScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const ScrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    const clientHeight2 = window.innerHeight;

    const isAtBottom = window.innerWidth < 430
      ? ScrollTop + clientHeight2 >= ScrollHeight - 100
      : ScrollTop + clientHeight >= ScrollHeight - 1;

    if (isAtBottom) {
      if (showPage === "Match" && newMatch.length < totalCards) {
        setCurrentIndex(prevIndex => prevIndex + 12);
      } else if (showPage === "Favorite" && favourite.length < totalCards2) {
        setCurrentIndex2(prevIndex => prevIndex + 12);
      } else if (showPage === "Like" && likeMe.length < totalCards3) {
        setCurrentIndex3(prevIndex => prevIndex + 12);
      } else if (showPage === "Passed" && passed.length < totalCards4) {
        setCurrentIndex4(prevIndex => prevIndex + 12);
      }
    }
  }, [favourite.length, likeMe.length, loading, newMatch.length, passed.length, showPage, totalCards, totalCards2, totalCards3, totalCards4]);

  useEffect(() => {
    const handleTouchMove = (e) => {
      console.log("Touchmove triggered");
      handleScroll();
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("touchmove", handleTouchMove);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, [handleScroll]);

  const DetailsHandler = (profile_id, name, sourceTab = showPage, profile = null) => {
    const Title = name.replace(/\s+/g, '_');
    const FinalText = Title.toLowerCase();
    sessionStorage.setItem("DetailsId", profile_id);
    sessionStorage.setItem("ExploreDetailSource", sourceTab || "");
    sessionStorage.setItem("ExploreDetailSuperLike", isSuperLikeProfile(profile) ? "1" : "0");
    naviget(`/detail/${FinalText}`, {
      state: {
        ProfileId: profile_id,
        sourceTab,
        isSuperLike: isSuperLikeProfile(profile),
      }
    });
  };

  const UserActionHandler = (Id, action) => {
    const uid = getUserId();
    if (!uid) return;
    const activeTab = showPage;
    const fallback = (payload = {}) => axios.post(`${basUrl}like_dislike`, {
      uid,
      profile_id: Id,
      action,
      client_action_id: payload.client_action_id,
    });
    emitProfileAction({ profileId: Id, action, fallback })
      .then((res) => {
        showTost({ title: res?.data?.ResponseMsg || "Action Recorded!" });
        removeProfileFromLists(Id);
        loadedTabsRef.current[activeTab] = false;
        if (action === "LIKE") {
          markTabsDirty(["Match", "Like", "Passed"]);
        } else {
          markTabsDirty(["Passed"]);
        }
      })
      .catch((error) => {
        showTost({ title: error.message || "Action failed!" });
      });
  };

  const tabs = [
    { key: "Match", label: "Matches" },
    { key: "Like", label: "Likes You" },
    { key: "Favorite", label: "Favourites" },
    { key: "Passed", label: "Second Chance" },
  ];

  const likesFilters = ["All", "Likes", "Super Likes"];

  const isSuperLikeProfile = (profile) => {
    if (!profile) return false;
    return Object.entries(profile).some(([key, value]) => {
      if (value === null || value === undefined) return false;
      const normalizedKey = String(key).toLowerCase();
      const normalizedValue = String(value).trim().toLowerCase();
      if ((normalizedKey.includes("super") || normalizedKey.includes("star")) &&
        ["1", "true", "yes", "3", "super_like", "superlike", "super_liked"].includes(normalizedValue)) {
        return true;
      }
      if (["action", "type", "like_type", "match_type", "status", "is_like", "like_status", "flag"].includes(normalizedKey)) {
        return normalizedValue.includes("super") || normalizedValue === "3";
      }
      return ["super_like", "superlike", "super_liked", "super_like_received"].includes(normalizedValue);
    });
  };

  const visibleLikeMe = useMemo(() => {
    const sorted = [...likeMe].sort((a, b) => Number(isSuperLikeProfile(b)) - Number(isSuperLikeProfile(a)));
    if (likesFilter === "Likes") return sorted.filter((profile) => !isSuperLikeProfile(profile));
    if (likesFilter === "Super Likes") return sorted.filter((profile) => isSuperLikeProfile(profile));
    return sorted;
  }, [likeMe, likesFilter]);

  const renderSuperLikeBadge = (profile, className = "left-[12px] top-[36px]") => {
    if (!isSuperLikeProfile(profile)) return null;
    return (
      <div className={`absolute ${className} z-[12] flex items-center gap-[4px] rounded-full bg-[rgba(152,14,255,255)] px-[10px] py-[4px] text-[11px] font-[700] text-white shadow-md border border-white/20`}>
        <span className="text-[12px]">&#9733;</span>
        <span>{t("Super Liked You")}</span>
      </div>
    );
  };

  const resolveProfileImage = (image) => {
    if (!image) return "";
    return /^https?:\/\//i.test(image) ? image : imageBaseURL + image;
  };

  const renderLockedPreviewCard = (profile, index) => {
    const image = profile?.profile_images?.[0] || profile?.profile_pic || "";
    return (
      <div key={index} className="custom-card card-rounded-1 relative overflow-hidden">
        <div className="position-relative">
          <div className="card-title rounded-1">
            <div className="card-img relative HEIGHT">
              <div className="absolute inset-0 z-[1] overflow-hidden rounded-[3rem] blur-[13px] scale-105">
                <div className="flex justify-end pe-[45px] w-[100%] absolute">
                  <h6 className="m-0 text-white font-[400] text-[14px] bg-[rgba(152,14,255,255)] p-2 rounded-b-[15px]">
                    {Number(profile?.match_ratio || 0).toFixed(0)}% {t("Match")}
                  </h6>
                </div>
                <div className="absolute left-[24px] top-[18px] z-[3] rounded-full bg-[rgba(152,14,255,255)] px-[10px] py-[5px] text-[12px] font-[700] text-white shadow-md">
                  {profile?.is_super_like === "1" ? (
                    <span><span>&#9733;</span> {t("Super Liked You")}</span>
                  ) : (
                    t("Liked You")
                  )}
                </div>
                {image ? (
                  <img src={resolveProfileImage(image)} alt="img" className="img-fluid rounded-[3rem] BEFORE border-[5px] border-[rgba(152,14,255,255)]" />
                ) : (
                  <div className="img-fluid rounded-[3rem] BEFORE border-[5px] border-[rgba(152,14,255,255)] bg-[#970eff18]" />
                )}
                <div className="card-content absolute bottom-[2rem] px-[20px] w-[100%]">
                  <div className="w-[70%]">
                    <div className="mb-[8px] h-[18px] w-[80%] rounded-full bg-white/80" />
                    <div className="h-[14px] w-full rounded-full bg-white/55" />
                  </div>
                </div>
              </div>
              <div className="absolute inset-0 z-[2] rounded-[3rem] bg-gradient-to-b from-black/15 via-[rgba(152,14,255,0.12)] to-[rgba(152,14,255,0.55)]" />
              <div className="absolute inset-0 z-[4] flex items-center justify-center px-[18px]">
                <button
                  onClick={() => naviget("/upgrade", { state: { returnTo: "/explore", tab: "Like" } })}
                  className="rounded-full bg-[rgba(152,14,255,255)] px-[28px] py-[12px] text-[15px] font-[800] text-white shadow-[0_12px_28px_rgba(152,14,255,0.35)]"
                >
                  {t("Upgrade")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderLockedLikes = () => {
    const previews = likesAccess.previews?.length
      ? likesAccess.previews
      : Array.from({ length: Number(likesAccess.count || 0) }, () => ({}));
    return (
      <div className="card p-[16px] card-rounded">
        <div className="mb-[18px] flex flex-wrap items-center justify-between gap-[12px]">
          <div>
            <h2 className="m-0 text-[24px] font-[800]">{t("Unlock Likes You")}</h2>
            <p className="m-0 mt-[4px] text-[15px] text-gray-500">
              {likesAccess.count > 0
                ? t("You have hidden likes waiting. Upgrade to reveal profiles and respond.")
                : t(likesAccess.reason || "Upgrade your plan to view premium likes.")}
            </p>
          </div>
          <button
            onClick={() => naviget("/upgrade", { state: { returnTo: "/explore", tab: "Like" } })}
            className="rounded-full bg-[rgba(152,14,255,255)] px-[28px] py-[12px] text-[15px] font-[800] text-white"
          >
            {t("Upgrade")}
          </button>
        </div>
        {previews.length > 0 ? (
          <div className="grid grid-cols-4 grid-transition grid-responsive gap-[18px]">
            {previews.map(renderLockedPreviewCard)}
          </div>
        ) : (
          <div className="flex min-h-[320px] items-center justify-center">
            <h2 className="m-0 text-center">{t("No Any User Like You...")}</h2>
          </div>
        )}
      </div>
    );
  };

  const renderStandardCard = (el, i, showActions = false) => (
    <div key={i} onClick={() => DetailsHandler(el.profile_id, el.profile_name, showPage, el)} className="custom-card cursor-pointer card-rounded-1 duration-300 ease-in-out z-[10] min-w-0 w-full" >
      <div className="relative rounded-[2rem] sm:rounded-[2.5rem] overflow-hidden shadow-lg border border-gray-100 bg-white">
        <div className="card-title overflow-hidden rounded-[2rem] sm:rounded-[2.5rem]">
          <div className="Coloreffect relative h-[420px] sm:h-[480px] overflow-hidden rounded-[2rem] sm:rounded-[2.5rem]">
            <div className="flex justify-center w-full absolute top-0 left-0 z-10">
              <h6 className="m-0 text-white font-[600] text-[13px] bg-[rgba(152,14,255,255)] px-3 py-1.5 rounded-b-[14px] shadow-sm">
                {Number(el.match_ratio || 0).toFixed(0)}% {t("Match")}
              </h6>
            </div>
            {renderSuperLikeBadge(el)}
            <img
              src={resolveProfileImage(el.profile_images?.[0] || el.profile_pic)}
              alt={el.profile_name}
              className="img-fluid object-cover w-full h-full border-0 outline-none"
            />
          </div>
          <div className="card-content absolute bottom-0 left-0 w-full z-10 bg-gradient-to-t from-black/85 via-black/40 to-transparent pt-10 pb-4 px-4">
            <div className="profile-info flex flex-col items-center">
              <div className="KM2 mb-1.5">
                <h6 className="m-0 flex items-center justify-center gap-1 text-white text-[13px] font-[600]">
                  <HiOutlineLocationMarker className="text-white text-[14px]" /> {el.profile_distance}
                </h6>
              </div>
              <div className="text-center">
                <h6 className="font-bold text-white text-[18px] sm:text-[20px] leading-tight">
                  {el.profile_name}, {el.profile_age}
                </h6>
              </div>
              <p className="bio text-[13px] sm:text-[14px] text-center mt-1 text-white/90 overflow-hidden text-ellipsis whitespace-nowrap w-full max-w-[90%]">
                {el.profile_bio && el.profile_bio !== "undefined" ? el.profile_bio : ""}
              </p>
              {showActions && (
                <div className="flex justify-center items-center gap-4 mt-3 z-20">
                  <button
                    type="button"
                    onClick={(e) => { e.stopPropagation(); UserActionHandler(el.profile_id, "UNLIKE"); }}
                    className="w-[46px] h-[46px] rounded-full bg-white/20 hover:bg-red-500/80 backdrop-blur-md flex items-center justify-center text-white transition-all shadow-lg active:scale-95"
                  >
                    <RxCross2 className="w-[24px] h-[24px]" />
                  </button>
                  <button
                    type="button"
                    onClick={(e) => { e.stopPropagation(); UserActionHandler(el.profile_id, "LIKE"); }}
                    className="w-[46px] h-[46px] rounded-full bg-[rgba(152,14,255,255)] hover:bg-[#8600e6] flex items-center justify-center text-white transition-all shadow-lg active:scale-95"
                  >
                    <FiHeart className="w-[22px] h-[22px] fill-current" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="main-wrapper bg-[#f8fafc] dashboard">
      <div className="content-body">
        <div className="container-fluid my-2 sm:my-4 px-2.5 sm:px-4">
          <div className="row">
            <div className="col-xl-12">
              <PageHeader
                title={t("Explore")}
                subtitle={t("Browse your matches, likes, favourites and second chances")}
                breadcrumbs={[{ label: t("Explore") }]}
                icon={FiHeart}
              />
            </div>

            <div className="col-xl-12 sticky top-[70px] z-[50] mb-3">
              <div className="bg-white rounded-xl sm:rounded-2xl p-2 sm:p-2.5 shadow-xs border border-gray-200/80">
                <div className="flex items-center gap-2 overflow-x-auto no-scrollbar py-0.5">
                  {tabs.map((tab) => {
                    const isActive = showPage === tab.key;
                    return (
                      <button
                        key={tab.key}
                        onClick={() => ShowPageHandler(tab.key)}
                        className={`inline-flex items-center gap-2 px-4 sm:px-5 py-2 sm:py-2.5 rounded-full text-[13px] sm:text-[14px] font-[600] whitespace-nowrap transition-all ${
                          isActive
                            ? "bg-[rgba(152,14,255,255)] text-white shadow-sm"
                            : "bg-[#970eff15] text-[#980EFF] hover:bg-[#970eff25]"
                        }`}
                      >
                        <FiHeart className={`w-3.5 h-3.5 ${isActive ? "fill-current" : ""}`} />
                        <span>{t(tab.label)}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="col-xl-12 pb-6">
              {showPage === "Match" && (
                newMatch.length > 0
                  ? <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3.5 sm:gap-5 bg-white rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-xs border border-gray-200/80">
                    {newMatch.map((el, i) => renderStandardCard(el, i))}
                  </div>
                  : <div className="p-6 bg-white rounded-2xl flex justify-center items-center min-h-[480px] shadow-sm border border-gray-100">
                    <h2 className="m-0 text-center text-gray-500 font-medium">{t('No Any Match Profiles...')}</h2>
                  </div>
              )}

              {showPage === "Like" && (
                likesAccess.isLocked
                  ? renderLockedLikes()
                  : likeMe.length > 0
                  ? <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3.5 sm:gap-5 bg-white rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-xs border border-gray-200/80">
                    <div className="col-span-full flex flex-wrap items-center gap-2 pb-3 mb-1 border-b border-gray-100">
                      {likesFilters.map((filter) => {
                        const active = likesFilter === filter;
                        return (
                          <button
                            key={filter}
                            onClick={() => setLikesFilter(filter)}
                            className={`rounded-full px-4 py-2 text-[13px] sm:text-[14px] font-[600] transition-all ${
                              active
                                ? "bg-[rgba(152,14,255,255)] text-white shadow-sm"
                                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                            }`}
                          >
                            {filter === "Super Likes" && <span className="mr-1 text-amber-300">&#9733;</span>}
                            {t(filter)}
                          </button>
                        );
                      })}
                    </div>
                    {visibleLikeMe.length > 0 ? (
                      visibleLikeMe.map((el, i) => renderStandardCard(el, i, true))
                    ) : (
                      <div className="col-span-full flex min-h-[320px] items-center justify-center">
                        <h2 className="m-0 text-center text-gray-500 font-medium">{t(likesFilter === "Super Likes" ? 'No Super Likes yet...' : 'No Any User Like You...')}</h2>
                      </div>
                    )}
                  </div>
                  : <div className="p-6 bg-white rounded-xl flex justify-center items-center min-h-[480px] shadow-xs border border-gray-200/80">
                    <h2 className="m-0 text-center text-gray-500 font-medium">{t(likesFilter === "Super Likes" ? 'No Super Likes yet...' : 'No Any User Like You...')}</h2>
                  </div>
              )}

              {showPage === "Favorite" && (
                favourite.length > 0
                  ? <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3.5 sm:gap-5 bg-white rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-xs border border-gray-200/80">
                    {favourite.map((el, i) => renderStandardCard(el, i))}
                  </div>
                  : <div className="p-6 bg-white rounded-xl flex justify-center items-center min-h-[480px] shadow-xs border border-gray-200/80">
                    <h2 className="m-0 text-center text-gray-500 font-medium">{t('No Any Favourite Profiles...')}</h2>
                  </div>
              )}

              {showPage === "Passed" && (
                passed.length > 0
                  ? <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3.5 sm:gap-5 bg-white rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-xs border border-gray-200/80">
                    {passed.map((el, i) => renderStandardCard(el, i))}
                  </div>
                  : <div className="p-6 bg-white rounded-xl flex justify-center items-center min-h-[480px] shadow-xs border border-gray-200/80">
                    <h2 className="m-0 text-center text-gray-500 font-medium">{t('No Any Passed Profiles...')}</h2>
                  </div>
              )}

              {loading && <div className="flex justify-center w-full bg-white rounded-2xl p-4 my-4 shadow-sm border border-gray-100">
                <LodingLottie ClassCss={"w-[10%] max-_430_:w-[30%] max-_1145_:w-[20%] max-_1200_:w-[20%] max-_1300_:w-[15%]"} />
              </div>}
            </div>
          </div>
        </div>
      </div>

      {isShow && (
        <div className="w-[100%] h-[100vh] ms-[8rem] max-_991_:ms-0 bg-white fixed flex items-center justify-center top-0 left-0 right-0 bottom-0 z-[555]">
          <LodingLottie ClassCss={"w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]"} />
        </div>
      )}
    </div>
  );
};

export default Favorites;
